mainApp.directive('iframeUrlsInParent', [function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.on('load', function() {
                const baseNode = element[0].contentWindow.document.createElement('base');
                baseNode.target = "_parent";
                element[0].contentWindow.document.head.appendChild(baseNode);
            });
        }
    }
}]);